import { connect, MapDispatchToProps } from 'react-redux';
import Homepage from '@/finsight/ui/components/staticPages/Homepage/Homepage';
import { setMetaTags } from '@/finsight/application/actions/metaTags/actions';

const mapDispatchToProps: MapDispatchToProps<any, any> = {
  setMetaTags,
};

export default connect(
  null,
  mapDispatchToProps,
)(Homepage);
